import React from 'react';

const TerminosYCondiciones = () => {
  return (
    <div className="bg-gray-100 text-gray-800 py-10 px-5 sm:px-10 md:px-20 lg:px-40">
      <div className="bg-white border-2 border-GrisOscuro rounded-lg p-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-6 text-center">Términos y Condiciones</h1>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">1. Información General</h2>
          <p className="mb-4">
            Los presentes Términos y Condiciones regulan el acceso y uso de los servicios ofrecidos por Agroh,
            entidad dedicada a la venta de productos agroquímicos, con domicilio en Av.Gobernador del Campo 441, S.M. de Tucumán.
            Al realizar un pedido o interactuar con nuestros servicios, usted acepta de manera plena y sin reservas los términos
            y condiciones aquí establecidos.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">2. Productos y Servicios</h2>
          <p className="mb-4">
            Agroh ofrece una gama de productos agroquímicos, tales como pesticidas, fertilizantes, herbicidas,
            entre otros, destinados a satisfacer las necesidades del sector agrícola. Todos nuestros productos están sujetos a
            disponibilidad. Los precios y características de los productos están sujetos a modificaciones sin previo aviso.
            El Cliente se compromete a utilizar los productos de acuerdo con las instrucciones del fabricante y en cumplimiento
            con las normativas legales vigentes en la jurisdicción aplicable.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">3. Pedidos</h2>
          <p className="mb-4">
            Los productos y servicios ofrecidos en Agroh solo se pueden adquirir a través de pedidos en línea.
            Los precios de los productos se encuentran establecidos en el sitio web y pueden estar sujetos a modificaciones.
            Al realizar un pedido, el Cliente acepta los precios y condiciones vigentes al momento de la solicitud.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">4. Precios y Condiciones de Pago</h2>
          <p className="mb-4">
            Los precios de los productos se encuentran establecidos en el sitio web de Agroh. El Cliente podrá
            efectuar el pago mediante los métodos habilitados por Agroh <strong><a href="http://localhost:3000/contacto" className="text-Verde">Consultar</a></strong>.
            El Cliente recibirá una confirmación de su pedido una vez que el pago haya sido procesado y autorizado.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">5. Envíos y Entregas</h2>
          <p className="mb-4">
            Agroh realiza envíos a las localidades especificadas en el sitio web. Los plazos de entrega dependerán
            de la ubicación y disponibilidad de los productos. El costo del envío será cubierto por el Cliente, quien asumirá los
            gastos correspondientes al servicio de transporte, los cuales serán detallados durante el proceso de pedido.
            Más detalles en <strong><a href="http://localhost:3000/envios" className="text-Verde">Detalle de Envíos</a></strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">6. Devoluciones y Reembolsos</h2>
          <p className="mb-4">
            Debido a la naturaleza de los productos comercializados, las devoluciones y reembolsos solo serán aceptados en
            situaciones excepcionales, tales como productos defectuosos o dañados durante el envío. Esto está detallado en <strong><a href="http://localhost:3000/devoluciones" className="text-Verde">Devoluciones</a></strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">7. Responsabilidad</h2>
          <p className="mb-4">
            El Cliente asume toda la responsabilidad por el uso adecuado de los productos adquiridos. Agroh no será
            responsable por daños directos, indirectos, incidentales o consecuentes que resulten del uso inapropiado, incorrecto o
            ilegal de los productos. El Cliente se compromete a cumplir con todas las normativas locales, estatales y federales
            aplicables, así como a seguir las recomendaciones del fabricante para la correcta utilización de los productos.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">8. Propiedad Intelectual</h2>
          <p className="mb-4">
            El contenido disponible en el sitio web de Agroh, incluyendo pero no limitándose a textos, imágenes,
            logotipos, gráficos y diseños, son propiedad exclusiva de Agroh o de sus licenciantes, y están
            protegidos por las leyes de propiedad intelectual. Queda expresamente prohibida la reproducción, distribución o uso
            no autorizado de dichos contenidos.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">9. Modificación de los Términos y Condiciones</h2>
          <p className="mb-4">
            Agroh se reserva el derecho de modificar, en cualquier momento y sin previo aviso, los presentes
            Términos y Condiciones. Las modificaciones entrarán en vigor de forma inmediata tras su publicación en el sitio web.
            Es responsabilidad del Cliente revisar periódicamente estos Términos y Condiciones para estar informado de cualquier cambio.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">10. Ley Aplicable y Jurisdicción</h2>
          <p className="mb-4">
            Este acuerdo será regido e interpretado de conformidad con las leyes de Argentina. Cualquier
            controversia derivada de la interpretación o ejecución de los presentes Términos y Condiciones será resuelta por los
            tribunales competentes de Tucumán, Argentina, renunciando expresamente las partes a cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-bold mt-6 mb-4">11. Contacto</h2>
          <p className="mb-4">
            Para cualquier consulta o aclaración sobre los Términos y Condiciones, el Cliente podrá ponerse en contacto con
            Agroh a través de los siguientes medios:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Correo electrónico: admin@agroh.info</li>
            <li>Teléfono: +54 381 5585138</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TerminosYCondiciones;
